/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LocatorMunicipioAliases {
  AUTOCOMPLETE_SG_ESTADO_NASC = 'autocomplete-sgEstadoNasc',
  BUTTON_SELECIONAR = 'button-selecionar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_0 = 'fetch-0',
  FETCH_9 = 'fetch-9',
  FIELD_0 = 'field-0',
  FIELD_SG_ESTADO_NASC = 'field-sgEstadoNasc',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  INPUT_0 = 'input-0',
  MAPPER_9 = 'mapper-9',
  PANEL_LOCATOR_MUNICIPIO = 'panel-locator-municipio',
  TABLE = 'table',
  TABLE_COLUMN_1 = 'table-column-1',
  TABLE_COLUMN_2 = 'table-column-2',
  TEXT_9 = 'text-9',
}
export { LocatorMunicipioAliases };
